// Canonical, globally-unique identifiers for every framework in `frameworksList`.
//
// This is the single declaration site for framework ID *values*. `frameworksList`
// (in ./list.ts) leads as the rich artifact, but each entry references one of these
// symbols via `frameworkId: FrameworkId`, and a completeness test in ./index.test.ts
// enforces a two-way 1:1 correspondence plus global uniqueness.
//
// Keep keys mechanical (hyphen -> underscore); human-readable context lives in each
// framework's `frameworkName`, not in the key.
export const FrameworkId = {
    ACT_1: "ACT-1",
    ACT_2: "ACT-2",
    ACT_3: "ACT-3",
    NAT_1: "NAT-1",
    NAT_2: "NAT-2",
    NAT_3: "NAT-3",
    NAT_4: "NAT-4",
    // Rating tools, not policies. Each is a SEPARATE certification scheme, or
    // scheme version, with its own credit set, categories and rating scale, so
    // Green Star takes five ids rather than sharing one "Green Star" entry.
    // Buildings v1.1
    NAT_5: "NAT-5",
    // Communities v2
    NAT_6: "NAT-6",
    // Fitouts v1
    NAT_7: "NAT-7",
    // Design & As Built v1.2
    NAT_10: "NAT-10",
    // Buildings v1, superseded by v1.1 (NAT_5) but still certified against,
    // with different credit numbers.
    NAT_11: "NAT-11",
    // IS Design & As Built v2.1 and IS Operations v2.1, parked until the IS
    // catalogue is re-identified.
    // NAT_8: "NAT-8",
    // NAT_9: "NAT-9",
    NSW_1: "NSW-1",
    NSW_2: "NSW-2",
    NSW_3: "NSW-3",
    NSW_4: "NSW-4",
    NT_1: "NT-1",
    NT_2: "NT-2",
    QLD_1: "QLD-1",
    QLD_2: "QLD-2",
    QLD_3: "QLD-3",
    QLD_4: "QLD-4",
    SA_1: "SA-1",
    SA_2: "SA-2",
    SA_3: "SA-3",
    SA_4: "SA-4",
    TAS_1: "TAS-1",
    TAS_2: "TAS-2",
    VIC_1: "VIC-1",
    VIC_2: "VIC-2",
    VIC_3: "VIC-3",
    VIC_4: "VIC-4",
    VIC_5: "VIC-5",
    VIC_6: "VIC-6",
    VIC_7: "VIC-7",
    WA_1: "WA-1",
    WA_2: "WA-2",
    WA_3: "WA-3"
};
export const frameworkIds = Object.values(FrameworkId);
